import { render } from "./calculator-component.vue?vue&type=template&id=e681ccaa&scoped=true"
import script from "./calculator-component.vue?vue&type=script&lang=js"
export * from "./calculator-component.vue?vue&type=script&lang=js"

import "./calculator-component.vue?vue&type=style&index=0&id=e681ccaa&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e681ccaa"]])

export default __exports__